/**
 * AudioFeatures Component
 *
 * Features section showcasing audio generation capabilities.
 */

import { memo } from 'react';
import { Volume2, Zap } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export const AudioFeatures = memo(function AudioFeatures() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
      <div className="text-center p-6">
        <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <Volume2 className="h-6 w-6 text-purple-600" />
        </div>
        <h3 className="font-semibold text-secondary-900 mb-2">
          {t('audioPage.features.providers.title')}
        </h3>
        <p className="text-sm text-secondary-600">{t('audioPage.features.providers.desc')}</p>
      </div>

      <div className="text-center p-6">
        <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <Zap className="h-6 w-6 text-pink-600" />
        </div>
        <h3 className="font-semibold text-secondary-900 mb-2">
          {t('audioPage.features.fastProcessing.title')}
        </h3>
        <p className="text-sm text-secondary-600">{t('audioPage.features.fastProcessing.desc')}</p>
      </div>
    </div>
  );
});
